<template>
    <div v-if="$route.query.type == '0'" class="reading-btn" @click="toPaperRead">阅读</div>
    <div v-else class="reading-btn" @click="toRead">阅读</div>
</template>

<script>
import { Toast } from "vant";
export default {
    name: "OnlineReading",
    components: {},
    props: {},
    data() {
        return {
            id: this.$route.query.id,
            type: this.$route.query.type,
        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {
        async toPaperRead() {
            if (sessionStorage.getItem("token")) {
                let res = await this.$apis.goodsServe.checkPaperGoods(this.$route.query.id);
                const { content, data } = res;
                if (res.resultCode === "200") {
                    if (content.code && (content.code == 10401007 || content.code == 10401008)) {
                        this.toRead();
                    } else if (content.code && content.code == 10401009) {
                        if (this.$route.query.out) {
                            if (this.$global.isAndroid_ios()) {
                                window.android.orderDetail(content.payBatchId);
                            } else {
                                window.webkit.messageHandlers.orderDetail.postMessage(
                                    content.payBatchId,
                                );
                            }
                        } else {
                            this.$router.push({
                                path: "/orderDetails",
                                query: { id: content.payBatchId, status: 1 },
                            });
                        }
                    } else {
                        let skuData = {
                            id: data.goodsSkuInfosDto.list[0].id,
                            skuId: data.goodsSkuInfosDto.list[0].id,
                            skuPrice: Number(data.price),
                            goodsTitle: data.goods.goodsName,
                            chargeWay: content.chargeWay,
                            selectedNum: Number(content.buyCount),
                            pictureUrl: "",
                            selectedText: "",
                            shopsName: data.shopsInfoDto.shopsName,
                        };
                        let skuParams = {
                            // 会议论文 || 期刊论文 type 5
                            type: 5,
                            skuData,
                        };
                        // 跟APP联调
                        if (this.$route.query.out) {
                            if (this.$global.isAndroid_ios()) {
                                window.android.confirmOrder(JSON.stringify(skuParams));
                            } else {
                                window.webkit.messageHandlers.confirmOrder.postMessage(
                                    JSON.stringify(skuParams),
                                );
                            }
                        } else {
                            localStorage.setItem("paperConfirmSku", JSON.stringify(skuParams));
                            // 跳转确认订单页;
                            this.$router.push({
                                name: "PaperConfirmOrder",
                            });
                        }
                    }
                } else {
                    Toast(res.resultDesc);
                }
            } else {
                if (this.$route.query.out) {
                    if (this.$global.isAndroid_ios()) {
                        window.android.getToken();
                    } else {
                        window.webkit.messageHandlers.getToken.postMessage("null"); //ios
                    }
                } else {
                    this.$router.push("/logins");
                }
            }
        },
        // 去阅读
        async toRead() {
            let obj = {
                articleId: this.id,
                articleType: this.type,
            };
            let res = await this.$apis.mainServe.hasFile(obj);
            if (res.resultCode === "1009") {
                if (this.$route.query.out) {
                    if (this.$global.isAndroid_ios()) {
                        window.android.getToken();
                    } else {
                        window.webkit.messageHandlers.getToken.postMessage("null"); //ios
                    }
                } else {
                    this.$router.push("/logins");
                }
            } else if (res.resultCode !== "200" && res.resultCode !== "1009") {
                this.$Message.error("没有文献");
                return false;
            } else if (res.resultCode === "200") {
                const url =
                    this.$apis.mainServe.readUrl +
                    "?articleId=" +
                    this.id +
                    "&articleType=" +
                    this.type +
                    "&token=" +
                    sessionStorage.getItem("token");
                if (this.$route.query.out) {
                    if (this.$global.isAndroid_ios()) {
                        window.android.getPdfUrl(url);
                    } else {
                        window.webkit.messageHandlers.getPdfUrl.postMessage(url);
                    }
                } else {
                    this.$router.push({
                        name: "openReading",
                        params: { url, title: "在线阅读" },
                    });
                }
            }
        },
    },
};
</script>

<style scoped lang="scss">
.reading-btn {
    padding: 10px 65px;
    background-color: #4a79f1;
    border-radius: 20px;
    font-size: 15px;
    font-weight: 700;
    color: #ffffff;
}
</style>
